// extracted by mini-css-extract-plugin
export default {"subscribeNotify":"A8OkzH","isMobile":"BWIRDY"};